import React from 'react';
import { ApiKeyCard } from './ApiKeyCard';
import { STATUS_COLORS } from '../constants';

interface ProviderData {
  keyValue: string;
  showKey: boolean;
  hasStoredKey: boolean;
  onKeyChange: (value: string) => void;
  onToggleShow: () => void;
  onSave: () => void;
  onRemove: () => void;
  onTestConnection?: () => void;
}

interface ApiKeysSectionProps {
  isActive: boolean;
  isLoading: boolean;
  openaiAdmin: ProviderData;
  openaiStandard: ProviderData;
  anthropic: ProviderData;
}

export const ApiKeysSection: React.FC<ApiKeysSectionProps> = ({
  isActive,
  isLoading,
  openaiAdmin,
  openaiStandard,
  anthropic
}) => {
  return (
    <section className={isActive ? 'space-y-3' : 'hidden'}>
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-3">
        <ApiKeyCard
          title="OpenAI Admin API Key"
          description="Required for OpenAI organization usage endpoints."
          placeholder="sk-admin-..."
          hasStoredKey={openaiAdmin.hasStoredKey}
          keyValue={openaiAdmin.keyValue}
          showKey={openaiAdmin.showKey}
          statusColorClass={openaiAdmin.hasStoredKey ? STATUS_COLORS.openaiAdmin.active : STATUS_COLORS.openaiAdmin.inactive}
          isLoading={isLoading}
          onKeyChange={openaiAdmin.onKeyChange}
          onToggleShow={openaiAdmin.onToggleShow}
          onSave={openaiAdmin.onSave}
          onRemove={openaiAdmin.onRemove}
          onTestConnection={openaiAdmin.onTestConnection}
          issuePageUrl="https://platform.openai.com/settings/organization/admin-keys"
          issuePageLabel="OpenAI Admin key issuance page"
        />
        <ApiKeyCard
          title="OpenAI API Key (Standard)"
          description="Optional key for standard OpenAI API workflows."
          placeholder="sk-proj-..."
          hasStoredKey={openaiStandard.hasStoredKey}
          keyValue={openaiStandard.keyValue}
          showKey={openaiStandard.showKey}
          statusColorClass={openaiStandard.hasStoredKey ? STATUS_COLORS.openaiStandard.active : STATUS_COLORS.openaiStandard.inactive}
          onKeyChange={openaiStandard.onKeyChange}
          onToggleShow={openaiStandard.onToggleShow}
          onSave={openaiStandard.onSave}
          onRemove={openaiStandard.onRemove}
        />
        <ApiKeyCard
          title="Anthropic Admin API Key"
          description="Required for Anthropic usage and cost report APIs."
          placeholder="sk-ant-..."
          hasStoredKey={anthropic.hasStoredKey}
          keyValue={anthropic.keyValue}
          showKey={anthropic.showKey}
          statusColorClass={anthropic.hasStoredKey ? STATUS_COLORS.anthropic.active : STATUS_COLORS.anthropic.inactive}
          onKeyChange={anthropic.onKeyChange}
          onToggleShow={anthropic.onToggleShow}
          onSave={anthropic.onSave}
          onRemove={anthropic.onRemove}
        />
      </div>
    </section>
  );
};
